import api from '@/store/api'
import cookies from 'js-cookie'
import router from '../../router'
import { getField, updateField } from 'vuex-map-fields'

export const state = {
	token: cookies.get('token'),
	isLoggedIn: false,
	loading: false,

	error: '',

	email: '',
	password: '',

	user: null
}

export const actions = {
	async login ({ commit }, payload) {
		state.loading = true

		const { data } = await api('post', '/insight/authenticate/login', payload)

		if (data.status !== 200) {
			state.error = data.errors
			state.user = null
			cookies.remove('token')
			state.loading = false
			return
		}

		// setting of token
		state.user = data.data
		state.token = data.data.api_token
		cookies.set('token', data.data.api_token, { expires: 36500 })
		state.isLoggedIn = true

		await router.push('/routers')
		state.loading = false
		commit('clearAuth')
	},

	async fetchUser () {
		state.loading = true

		const { status, data } = await api('post', '/insight/authenticate/fetch-user')

		if (status) {
			state.isLoggedIn = true
			state.user = data.data
		} else {
			state.isLoggedIn = false
			state.token = null
			cookies.remove('token')
		}

		state.loading = false
	},

	async signOut () {
		state.loading = true

		const { status } = await api('post', '/insight/authenticate/logout')

		if (!status) {
			this.$store.dispatch('banner/toggleBanner', {
				status: true,
				message: 'Something went wrong',
				type: 'error'
			})
			return
		}

		state.isLoggedIn = false
		state.token = ''
		cookies.remove('token')
		location.reload()

		state.loading = false
	}
}

export const mutations = {
	updateField,

	clearAuth () {
		state.email = ''
		state.password = ''
		state.error = ''
		state.loading = false
	}

}

const getters = {
	getField
}

export default {
	state,
	actions,
	mutations,
	getters
}
